import { SVGIconComponent } from '../types';

export const locationOff: SVGIconComponent = ({ title = '', ...props }) => (
  <svg data-dir="ltr" viewBox="0 0 12 14" {...props}>
    <title>{title}</title>
    <path d="M6.667 3.333c.92 0 1.666.747 1.666 1.667 0 .493-.22.927-.553 1.233l2.42 2.42c.653-1.24 1.133-2.533 1.133-3.653a4.663 4.663 0 0 0-8.026-3.233l2.126 2.126a1.63 1.63 0 0 1 1.234-.56ZM.847 1 0 1.847l2.12 2.12C2.047 4.3 2 4.647 2 5c0 3.5 4.667 8.667 4.667 8.667s1.113-1.234 2.253-2.9L11.153 13l.847-.847L.847 1Z" />
  </svg>
);
